var _g, _g2, _path, _path2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationLogin = function SvgIllustrationLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-login_svg__a)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7E6F5",
    d: "M252.804 427.696c-8.338 5.009-23.102 5.367-32.995.825l-87.117-39.934c-9.909-4.542-11.185-12.274-2.862-17.268l140.911-84.58c8.322-4.994 23.101-5.367 32.995-.825l87.116 39.934c9.894 4.542 11.17 12.274 2.847 17.267z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-login_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7F6",
    fillRule: "evenodd",
    d: "M299.881 220.608a8 8 0 0 1-2.295 11.078l-204 134a8 8 0 0 1-8.784-13.373l204-134a8.001 8.001 0 0 1 11.079 2.295",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__c)",
    d: "M247.038 381.05c-8.338 5.009-23.101 5.367-32.995.824l-87.117-39.933c-9.909-4.543-11.185-12.274-2.862-17.268l140.911-84.581c8.323-4.993 23.101-5.367 32.995-.824l87.117 39.933c9.894 4.543 11.169 12.274 2.846 17.268z",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__d)",
    d: "M390.13 271.242c0 .196 0 .391-.105.587-.105.196-.075.301-.12.466a5.46 5.46 0 0 1-.196.527 4.23 4.23 0 0 1-.196.467l-.285.526c-.08.152-.17.298-.271.437a4.716 4.716 0 0 1-.407.556l-.331.407a7.21 7.21 0 0 1-.662.692 2.714 2.714 0 0 1-.301.286c-.414.377-.851.729-1.309 1.053-.346.241-.692.467-1.068.692l-136.283 81.857c-.557.331-1.129.632-1.73.918l-.362.166a23.8 23.8 0 0 1-2.347.933l-.436.15c-.873.286-1.791.527-2.739.737l-.888.196-.918.18-1.083.166-.948.135h-.858c-.571 0-1.143.106-1.73.136h-5.342l-.933-.075-1.173-.121-.888-.12c-.391 0-.783-.105-1.159-.181l-.903-.15-1.098-.241c-.316 0-.647-.135-.963-.226l-.963-.255-1.144-.347c-.271 0-.541-.18-.812-.27a28.746 28.746 0 0 1-1.686-.647l-.812-.347-84.265-38.626c-5.417-2.483-8.17-6.019-8.08-9.374v2.317c-.09 3.431 2.648 6.907 8.065 9.39l84.265 38.626.391.165c.135 0 .286.121.421.181l1.701.647.361.135.451.136 1.129.346.541.15.437.106.963.225.602.151h.496l.888.165.572.106.587.075.903.12H234.557l1.655.241h.512c.115.008.231.008.346 0l.948-.12 1.098-.181.918-.165.632-.121.256-.075a30.5 30.5 0 0 0 2.739-.752l.421-.151a21.986 21.986 0 0 0 2.362-.933l.241-.09h.12a20.738 20.738 0 0 0 1.716-.918l136.298-81.812c.331-.195.662-.406.963-.617l.09-.075a14.12 14.12 0 0 0 1.324-1.053h.075l.226-.226c.241-.241.467-.466.662-.692l.136-.136.195-.27c.136-.181.286-.377.407-.557.12-.181.105-.136.135-.196.051-.077.096-.157.135-.241.106-.18.196-.361.286-.541.091-.181.091-.151.121-.226.03-.075 0-.15.075-.226.075-.075.135-.361.196-.541.025-.087.055-.172.09-.256v-.196c.045-.193.075-.389.09-.587v-2.949c.04.109.075.219.105.331"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__e)",
    d: "M248.596 359.795c-8.065 4.846-22.345 5.192-31.915.798l-84.265-38.626c-9.585-4.394-10.819-11.873-2.768-16.703l136.298-81.812c8.05-4.83 22.345-5.191 31.915-.797l84.264 38.626c9.57 4.394 10.804 11.872 2.754 16.703z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-login_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__g)",
    d: "M287.388 244.187c6.621-3.987 15.905-4.213 20.66-.527l2.182 1.701c4.77 3.686 3.265 9.961-3.356 13.949l-100.606 60.655c-6.62 3.987-15.89 4.213-20.645.512l-2.181-1.686c-4.77-3.701-3.281-9.946 3.34-13.949zM243.3 284.679l-1.505-1.128-4.078 3.009.151-3.792-2.513.512 1.188 3.431-4.83-1.219-1.068 1.685 5.417.346-4.785 2.332 1.505 1.129 3.987-3.009-.165 3.957 2.467-.421-1.083-3.521 4.785 1.249 1.113-1.731-5.447-.271 4.891-2.422m-37.122 22.239-1.505-1.143-4.062 3.009.135-3.792-2.513.512 1.189 3.431-4.845-1.204-1.069 1.685 5.417.331-4.8 2.318 1.505 1.128 3.988-3.009-.211 3.746 2.468-.436-1.084-3.506 4.8 1.249 1.099-1.715-5.432-.286 4.89-2.408m49.46-29.823-1.504-1.144-4.063 3.009.135-3.776-2.513.511 1.189 3.431-4.83-1.204-1.068 1.67 5.417.346-4.8 2.318 1.504 1.143 3.988-3.009-.196 3.747 2.468-.437-1.084-3.506 4.801 1.264 1.098-1.745-5.432-.271 4.89-2.408m37.107-22.375-1.505-1.128-4.078 3.009.136-3.792-2.513.512 1.189 3.43-4.831-1.203-1.068 1.67 5.417.346-4.785 2.317 1.505 1.144 3.987-3.01-.21 3.747 2.467-.421-1.083-3.521 4.8 1.249 1.098-1.731-5.432-.271 4.906-2.407m-74.198 44.946-1.505-1.129-4.078 3.01.151-3.792-2.528.512 1.204 3.43h-.076l-4.83-1.203-1.068 1.67 5.417.346-4.725 2.392 1.505 1.144 3.987-3.009-.195 3.731 2.452-.421-1.083-3.521L217.96 304l1.114-1.731-5.448-.27 4.906-2.408m12.354-7.448-1.505-1.144-4.078 3.009.166-3.791-2.528.496 1.188 3.446-4.83-1.204-1.068 1.67 5.417.362-4.785 2.317 1.505 1.143 4.002-3.009-.211 3.732 2.483-.422-1.113-3.506h.075l4.785 1.264 1.099-1.73-5.433-.286 4.891-2.408m37.106-22.375-1.504-1.128-4.063 3.009.15-3.792-2.528.512 1.204 3.431-4.845-1.189-1.068 1.67 5.432.346-4.8 2.332 1.504 1.129 4.003-3.009-.256 3.867 2.483-.422-1.099-3.521 4.8 1.249 1.099-1.73-5.432-.271 4.89-2.408m12.354-7.448-1.505-1.144-4.062 3.01.15-3.792-2.528.512 1.189 3.43-4.845-1.203-1.069 1.685 5.432.331-4.8 2.317 1.505 1.144 4.002-3.01-.225 3.747 2.483-.436-1.099-3.506 4.8 1.249 1.099-1.716-5.432-.286 4.875-2.407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C5CCB",
    d: "m260.077 268.369 2.513-.512-.135 3.792.03.03 4.077-3.039 1.46 1.128-4.875 2.408.045.03 5.432.286-1.099 1.73-4.8-1.249-.06.031 1.084 3.521-2.468.421.211-3.747-.046-.03-4.002 2.979-1.46-1.143 4.785-2.317-.045-.031-5.417-.346 1.068-1.685 4.846 1.204.045-.03zM247.708 275.817l2.528-.497-.15 3.777.045.03 4.063-3.039 1.459 1.143-4.875 2.393.045.045 5.432.271-1.113 1.745-4.785-1.264-.06.03 1.098 3.521-2.483.422.211-3.732-.045-.03-4.003 2.964-1.459-1.128 4.8-2.333-.045-.03-5.433-.346 1.069-1.67 4.845 1.204.045-.045zM210.602 298.192l2.528-.511-.151 3.792.045.03 4.078-3.055 1.46 1.144-4.891 2.407.045.045 5.432.271-1.098 1.731-4.785-1.249-.075.03 1.098 3.521-2.468.421.211-3.747-.045-.03-4.003 2.98-1.459-1.144 4.785-2.317-.045-.03-5.417-.346 1.053-1.686 4.845 1.204.06-.03zM272.446 260.905l2.513-.497-.136 3.777.031.03 4.062-3.039 1.475 1.143-4.89 2.408.045.03 5.447.271-1.114 1.73-4.785-1.249-.06.03 1.084 3.521-2.468.437.21-3.747-.045-.045-4.002 2.994-1.475-1.143 4.8-2.318-.045-.045-5.417-.346 1.068-1.67 4.831 1.204.06-.03zM235.34 283.28l2.527-.511-.15 3.791.03.031 4.078-3.055 1.475 1.144-4.906 2.407.06.045 5.432.271-1.113 1.731-4.785-1.249-.06.03 1.098 3.506-2.468.436.196-3.747-.045-.03-3.988 2.98-1.474-1.144 4.8-2.317-.045-.045-5.432-.331 1.068-1.686 4.83 1.204.075-.03zM222.986 290.728l2.513-.511-.151 3.792.045.03 4.063-3.04 1.475 1.129-4.891 2.422.046.03 5.432.271-1.099 1.731-4.8-1.249-.06.045 1.098 3.506-2.467.421.195-3.731-.045-.046-3.987 2.98-1.475-1.129 4.8-2.317-.06-.045-5.402-.346 1.068-1.67 4.83 1.203.061-.045zM198.248 305.656l2.513-.511-.136 3.776.03.03 4.078-3.039 1.46 1.128-4.89 2.423.045.03 5.432.271-1.099 1.73-4.785-1.248-.06.03 1.083 3.521-2.467.421.21-3.732-.045-.045-4.002 2.98-1.46-1.129 4.785-2.317-.045-.045-5.432-.347 1.068-1.67 4.845 1.204.061-.03zM285.507 257.775l-4.785 2.318 1.46 1.143 4.002-2.979.045.03-.225 3.747 2.482-.421-1.098-3.522.075-.03 4.785 1.249 1.099-1.73-5.432-.271-.046-.045 4.891-2.408-1.46-1.143-4.078 3.054-.045-.03.151-3.792-2.528.512 1.204 3.431-.061.03-4.845-1.204-1.068 1.685 5.432.346z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__h)",
    d: "M313.901 251.681v-.753c0-.18 0-.436-.105-.662l-.256-1.128a7.16 7.16 0 0 0-2.754-4.153l-2.181-1.701c-4.981-3.852-14.657-3.611-21.563.557l-100.606 60.656c-4.921 3.009-7.117 7.147-6.169 10.698a1.079 1.079 0 0 1 0-.241l.255 1.144a7.194 7.194 0 0 0 2.754 4.093l2.167 1.685c.393.297.806.568 1.234.813l.391.195c.342.184.694.35 1.053.497l.376.15c.497.196.994.346 1.505.497h.241c.461.12.928.215 1.399.286h.497l1.324.12h3.852l.767-.09h.151l.542-.09.632-.106h.24l.572-.135.497-.105.331-.091.602-.18.346-.106.376-.135.662-.226.346-.12.346-.151c.286-.12.557-.225.828-.361l.361-.15.211-.106a20.02 20.02 0 0 0 1.504-.812h.151l100.606-60.655a22.035 22.035 0 0 0 1.61-1.084c.165-.12.301-.256.451-.376.151-.12.632-.527.918-.783l.466-.481c.241-.256.482-.497.693-.752l.406-.527c.105-.151.241-.286.331-.436.056-.087.106-.178.15-.271.166-.256.301-.527.437-.783.135-.256.165-.271.226-.406.041-.088.076-.178.105-.271 0-.165.12-.316.165-.466.06-.127.11-.258.151-.392 0-.165.075-.346.12-.511.045-.166 0-.211 0-.316v-.166c0-.301 0-.617.075-.918.226-.12.211-.165.211-.195m-127.119 53.162 100.606-60.656c6.621-3.987 15.905-4.213 20.66-.526l2.182 1.685c4.77 3.702 3.265 9.976-3.356 13.964l-100.606 60.655c-6.621 3.988-15.89 4.213-20.645.512l-2.181-1.685c-4.77-3.702-3.281-9.947 3.34-13.949m-5.793 12.143c.075.12.135.241.226.361-.091-.12-.151-.241-.286-.361zm127.841-58.414.286-.21-.18.15zm4.755-6.696v-.24a.195.195 0 0 1 0 .09.45.45 0 0 1-.075.15z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__i)",
    d: "M279.582 50.632c10.567-6.113 19.187-1.215 19.283 10.952l.328 117.628c0 12.149-8.523 26.997-19.09 33.071L99.611 316.413c-10.586 6.113-19.283 1.196-19.283-10.953L80 187.832c0-12.168 8.523-26.997 19.11-33.071z",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__j)",
    d: "M267.97 82.897c8.246-4.77 14.972-.948 15.047 8.547l.256 91.788c0 9.48-6.651 21.066-14.897 25.806l-140.842 81.255c-8.261 4.77-15.047.933-15.047-8.547l-.256-91.788c0-9.495 6.651-21.066 14.912-25.806z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__k)",
    fillRule: "evenodd",
    d: "M276.408 80.565a7.256 7.256 0 0 0-1.518-.64l-.013-.007a8.156 8.156 0 0 0-.226-.059 8.13 8.13 0 0 0-1.529-.24l-.006-.002a10.194 10.194 0 0 0-2.089.107l-.002-.002-.12.021c-.39.064-.786.151-1.19.26l-.014.005c-.572.156-1.156.358-1.752.606l-.009-.005c-.716.301-1.411.65-2.079 1.047l-.013-.008-140.842 81.316 2.122 1.234 140.83-81.309.012.008a18.09 18.09 0 0 1 2.144-1.067l.023.014a15.218 15.218 0 0 1 1.761-.602l-.024-.014a15.29 15.29 0 0 1 1.017-.228c.247-.044.492-.079.733-.105.217-.022.434-.037.651-.045l-.008-.004a9.164 9.164 0 0 1 1.024.01l.812.095.134.024.69.16.054.016h.002l.798.287-.032-.019.004.002.028.016c.246.102.485.219.717.35l.02.011h.012l.035.02-.034-.02h.078l-2.122-1.234zM112.216 190.017v-.002c-.001-.981.064-1.96.196-2.932.09-.677.21-1.369.361-2.061l-.024-.014v-.001l.024.015c.12-.572.256-1.144.406-1.716l-.013-.008.013.008m-.963 6.711.256 91.833zm.256 91.833-2.122-1.234zm-2.122-1.234-.255-91.833zm-.255-91.833c-.002-.976.063-1.951.195-2.919zm.195-2.919a25.12 25.12 0 0 1 .278-1.676zm.278-1.676c.046-.235.096-.47.149-.706zm.149-.706c.103-.47.217-.94.341-1.41zm.341-1.41.012.007zm.012.007-.012-.007zm-.012-.007c.15-.512.301-1.023.466-1.505zm.466-1.505.006.003zm.006.003.004-.011zm.004-.011-.01-.006zm-.01-.006c.166-.482.331-.948.512-1.415zm.512-1.415.005.004zm.005.004v-.001zm0-.001-.005-.003zm-.005-.003c.128-.35.274-.699.417-1.042zm.417-1.042.124-.297zm.124-.297c.196-.437.392-.873.602-1.294zm.602-1.294.001.001zm.001.001.001-.001zm.001-.001-.002-.001zm-.002-.001c.211-.436.422-.857.647-1.279zm.647-1.279c.226-.421.452-.842.692-1.263zm.692-1.263.01.005zm.01.005c.249-.428.507-.851.774-1.268zm.774-1.268-.001-.001zm-.001-.001.049-.074zm.049-.074c.32-.5.653-.991.996-1.472zm.996-1.472c.251-.361.515-.716.791-1.065zm.791-1.065c.381-.493.773-.973 1.176-1.439zm1.176-1.439.088-.103zm.088-.103.001.001zm.001.001a30.716 30.716 0 0 1 2.126-2.208zm2.126-2.208a24.026 24.026 0 0 1 2.486-2.065zm2.486-2.065a22.04 22.04 0 0 1 1.992-1.296zm1.992-1.296 2.122 1.234zm2.122 1.234c-.362.211-.718.431-1.068.66zm-1.068.66a25.938 25.938 0 0 0-3.689 2.97zm-3.689 2.97-.209.207zm-.209.207a26.161 26.161 0 0 0-1.64 1.746zm-1.64 1.746-.008-.005zm-.008-.005-.206.238zm-.206.238c-.346.404-.683.82-1.02 1.256zm-1.02 1.256c-.341.442-.672.893-.993 1.355zm-.993 1.355-.013-.008zm-.013-.008.013.008zm.013.008c-.301.421-.602.858-.872 1.294zm-.872 1.294-.012-.007zm-.012-.007-.017.026zm-.017.026.044.026zm.044.026c-.271.421-.527.843-.783 1.264zm-.783 1.264c-.241.421-.466.842-.692 1.264zm-.692 1.264-.015-.045zm-.015-.045c-.226.421-.436.842-.647 1.278zm-.647 1.278-.02-.011zm-.02-.011.02.012zm.02.012c-.211.421-.406.857-.602 1.294zm-.602 1.294-.124.296zm-.124.296c-.143.343-.289.693-.418 1.043zm-.418 1.043-.019-.012zm-.019-.012v.001zm0 .001.019.011zm.019.011c-.18.467-.346.933-.511 1.415zm-.511 1.415-.017-.01zm-.017-.01-.004.012zm-.004.012.021.012zm.021.012c-.135.403-.259.816-.382 1.223zm1.068 108.401 2.095 1.218c-1.26-.736-2.299-1.868-3.044-3.353-.823-1.647-1.285-3.733-1.293-6.216l-2.122-1.234c.015 4.71 1.686 8.08 4.364 9.585",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__l)",
    fillRule: "evenodd",
    d: "m219.201 190.168.001.001h.981l.027.015h.015c.301.019.6.053.897.102l.006.003h-.015l.873.196-.16-.091h.002l.158.091.812.285-.275-.156.042.015.248.142.768.376-.64-.365.003.002.637.363.015.015h.075l-.29-.169c.091.048.181.097.269.148l-1.469-.852a7.855 7.855 0 0 0-1.97-.741 2.116 2.116 0 0 0-.572-.116h-.001a6.227 6.227 0 0 0-.904-.105l-.029-.016a7.357 7.357 0 0 0-1.007 0h-.001a9.951 9.951 0 0 0-1.143.12l.012.007-.013.002-.014-.008c-.452.068-.899.163-1.34.286l.004.002c-1.246.328-2.554.863-3.901 1.622l.024.015-.054.03.008.005-17.944 10.363 1.489.858 17.939-10.36.013.007a19.99 19.99 0 0 1 2.137-1.068l-.028-.016.028.015h.015a14.886 14.886 0 0 1 1.79-.616l-.008-.005c.458-.118.888-.207 1.332-.281l-.052-.029.013-.002.054.031c.376-.121.767-.121 1.143-.121m-39.634 38.883-1.504-.873v-.001a25.714 25.714 0 0 1 .195-3.009l.004.002c.09-.683.209-1.381.357-2.078l.009.005-.008-.005c.135-.587.27-1.174.436-1.761l.006.004v-.001l-.006-.003c.106-.373.213-.738.33-1.085l.153-.47-.017-.01c.089-.283.188-.567.291-.862.072-.207.147-.42.221-.642l.031.018c.174-.45.35-.885.552-1.321l-.011-.006c.18-.452.391-.903.602-1.34l.021.012.003-.006-.009-.005c.21-.436.436-.872.661-1.309h.001l.01.005-.01-.006.722-1.294c.256-.437.527-.873.797-1.294h.001c.286-.451.586-.903.887-1.339l.01.005c.334-.477.679-.945 1.033-1.402l-.004-.002c.251-.327.509-.641.768-.948a32.646 32.646 0 0 1 2.169-2.361l-.003-.002a25.441 25.441 0 0 1 2.724-2.358 22.914 22.914 0 0 1 2.331-1.554h.001l1.504.873a25.004 25.004 0 0 0-5.056 3.912l-.007-.004-.019.018.026.016a27.3 27.3 0 0 0-1.685 1.776l-.008-.005c-.413.487-.826.988-1.225 1.475l.06.034a29.57 29.57 0 0 0-1.039 1.385l-.053-.031-.076.11c-.283.411-.565.836-.834 1.26-.271.421-.542.857-.797 1.309-.256.421-.497.857-.723 1.294l-.007-.005v.001l.007.004c-.225.422-.451.858-.662 1.294l-.002-.001c-.213.441-.417.886-.611 1.333l.012.007c-.153.351-.296.712-.437 1.067l-.12.302h-.015l-.002-.001c-.192.5-.372 1.002-.538 1.504l.028.017a52.863 52.863 0 0 0-.466 1.505l-.015-.015-.005-.003.005.003c-.078.274-.152.548-.221.823-.18.726-.329 1.45-.448 2.169-.048.296-.091.593-.129.89l-.002-.001a22.945 22.945 0 0 0-.193 2.729z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__m)",
    d: "M212.777 192.26c8.441-4.875 15.333-.948 15.363 8.742v.407l-48.573 28.002v-.391c0-9.705 6.817-21.562 15.258-26.423zm-32.502 35.978 47.158-27.221c-.211-9.028-6.711-12.549-14.656-7.96l-17.876 10.368c-7.93 4.514-14.401 15.634-14.551 24.813"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__n)",
    d: "M212.777 193.058c7.945-4.515 14.445-1.008 14.656 7.96l-47.158 27.22c.15-9.179 6.62-20.238 14.55-24.813z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__o)",
    fillRule: "evenodd",
    d: "M189.551 188.226c-.95-1.672-1.488-3.863-1.497-6.499.002-.951.062-1.901.181-2.844l.002.001c.09-.673.21-1.345.344-2.018l.025.015.003-.013-.028-.016c.12-.554.255-1.109.419-1.663l-.013-.008c.141-.491.291-.993.452-1.504l.004.002c.149-.447.313-.909.477-1.357l.041.023.002-.007-.028-.016c.165-.434.345-.868.539-1.287l-.012-.007.001-.002c.18-.421.36-.841.571-1.262.195-.406.406-.812.616-1.218l.001-.001.032.019.004-.007-.021-.012c.21-.411.436-.818.677-1.219l.001-.001c.24-.406.481-.812.736-1.218v.001l.838-1.228-.01-.006c.301-.436.617-.873.948-1.294l.027.016c.374-.484.76-.954 1.156-1.41l-.01-.005a40.16 40.16 0 0 1 1.505-1.625l.023.013.011-.011-.004-.003a23.444 23.444 0 0 1 4.627-3.591l-.008-.005c.627-.36 1.276-.681 1.941-.963l.011.006.008-.003-.003-.002a16.07 16.07 0 0 1 1.64-.572c.384-.096.756-.18 1.127-.24l.195-.03a9.256 9.256 0 0 1 1.371-.102c5.942-1.086 10.263 2.998 10.263 10.694 0 9.645-6.681 21.367-14.942 26.137-6.573 3.795-12.212 2.065-14.243-3.658m3.937 3.496c2.596 1.689 6.257 1.565 10.306-.771 7.809-4.514 14.159-15.604 14.129-24.738-.017-5.126-2.034-8.56-5.184-9.789l-.586-.199-.018-.005-.578-.142a7.975 7.975 0 0 0-1.098-.142h-.902v-.005a10.46 10.46 0 0 0-2.225.353l-.048.014-.08.021a12.414 12.414 0 0 0-1.237.413c-.108.044-.216.09-.323.137l-.006-.003c-.63.263-1.273.584-1.927.961l.008.005c-2.205 1.274-4.294 3.074-6.155 5.206l-.012.015c-.205.235-.408.474-.607.717-.182.225-.361.454-.539.683l-.004-.002c-4.096 5.275-6.833 12.13-6.813 18.133 0 4.515 1.61 7.795 4.183 9.3z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__p)",
    d: "M203.688 157.832c7.825-4.514 14.205-.767 14.235 8.381.03 9.149-6.32 20.224-14.129 24.738-7.81 4.514-14.22.767-14.235-8.366-.015-9.134 6.32-20.239 14.129-24.753"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-login_svg__q)",
    d: "m112.5 190-2.5-1.5c.712 21.167.5 66 0 85s5.621 19.833 9.5 19c0 0-7-2.948-7-10z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__c",
    x1: 71.901,
    x2: 480.019,
    y1: 310.761,
    y2: 425.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#D1DFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#D1DFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__d",
    x1: 133.364,
    x2: 307.611,
    y1: 291.014,
    y2: 411.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#2C5CCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__e",
    x1: 215.372,
    x2: 400.453,
    y1: 163.865,
    y2: 359.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#BFD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C5CCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__g",
    x1: 365.092,
    x2: 182.268,
    y1: 198.474,
    y2: 315.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#BFD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__h",
    x1: 266.258,
    x2: 290.027,
    y1: 228.852,
    y2: 319.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__i",
    x1: 183,
    x2: 421.98,
    y1: 392,
    y2: 66.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#8EB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__j",
    x1: 185.331,
    x2: 259.758,
    y1: 56.279,
    y2: 247.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__k",
    x1: 194.352,
    x2: 194.352,
    y1: 79.6,
    y2: 291.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__l",
    x1: 228.215,
    x2: 182.321,
    y1: 182.675,
    y2: 232.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__m",
    x1: 203.854,
    x2: 203.854,
    y1: 190.165,
    y2: 229.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#9FBCFF",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__n",
    x1: 237.244,
    x2: 196.311,
    y1: 142.048,
    y2: 234.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__o",
    x1: 207.815,
    x2: 226.526,
    y1: 149.439,
    y2: 184.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__p",
    x1: 234.234,
    x2: 183.826,
    y1: 119.476,
    y2: 199.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-login_svg__q",
    x1: 114.606,
    x2: 115.523,
    y1: 322.102,
    y2: 181.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AEEA73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AEEA73",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AEEA73",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEEA73",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AEEA73",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEEA73",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-login_svg__a",
    width: 286.896,
    height: 161.006,
    x: 118.317,
    y: 276.717,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1473_109927",
    stdDeviation: 3.009
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-login_svg__b",
    width: 228.002,
    height: 158.002,
    x: 77.193,
    y: 212.999,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1473_109927",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-login_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M180.011 240.606h133.89v84.069h-133.89z"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationLogin);
export default Memo;